import React from 'react';
import {connect} from 'react-redux';
import { getLocalizedPath } from '../../helpers/languagePath';

export default function(ComposedComponent) {
  class AuthRoutes extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          basePath : window.location.protocol + '//' + window.location.host
        }
      }
    
    getHtml = () => {
      if(localStorage.getItem('Islogin') === 'true'){
        // Keep /hi or /pa so post-login dashboard route matches language routes
        window.location.href = this.state.basePath + getLocalizedPath('myaccount');
        return null;
      } else {
        return <ComposedComponent {...this.props} />
      }
    }

    render() {
      return(this.getHtml())
    }
  }

  function mapStateToProps(store) {
    return store
  }

  return connect(mapStateToProps)(AuthRoutes);
}
